export const DAILY_BUCKET = "daily";
/** The sign-up bonus, granted once on account creation. */
export const SIGNUP_BONUS_BUCKET = "nonExpiring";
/**
 * Purchased top-ups. TODO: confirm the exact backend key — the top-up product
 * isn't live yet (DEV-3209), and "nonExpiring" describes purchased credits just
 * as well as granted ones, so they may well land in that bucket instead. If
 * they do, the silence rule breaks: a user who paid would have their balance
 * hidden. Worth settling before top-ups ship.
 */
export const TOP_UP_BUCKET = "topUp";
/** Credits left in a bucket, treating an unlimited daily bucket as no number. */
export const bucketRemaining = (bucket) => {
    if (!bucket)
        return 0;
    if ("unlimited" in bucket && bucket.unlimited)
        return 0;
    return bucket.remaining ?? 0;
};
export const isUnlimited = (total) => total === "unlimited";
//# sourceMappingURL=credits.types.js.map